import Vue from "vue";
import { QuickOrderFormToggler } from "../components/QuickOrderForm";
import { FormField } from "../components/FormField";

require('../components/slick');


Vue.component('tracking', {
    components: {
        FormField
    },
    data: () => {
        return {
            term: '',
            carrier: 'all',
            carriers: global.carriers,
            settings: {
               minimumResultsForSearch: -1
            }
        };
    },
    methods: {
        submit() {
            if(this.carrier === 'all')
                location.href = '/sledzenie-przesylki/status/' + encodeURIComponent(this.term);
            else
                location.href = '/sledzenie-przesylki/status/' + encodeURIComponent(this.term) + '?carrier=' + this.carrier;
        }
    },
    template: `
      <div class="row row-full section_tracking">
            <div class="main__content">
                <div class="row">
                    <div class="gr-12">
                        <div class="gr-12 heading heading--big" style="">
                            Śledzenie przesyłek
                        </div>
                        <form class="tracking" @submit.prevent="submit" v-cloak>
                            <div class="gr-5 gr-12@tablet gr-12@mobile gr-centered">
                              <div style="display: flex; align-items: center; position: relative;">
                                <div is="FormField" type="text" name="term" v-model="term"
                                     placeholder="Wpisz numer przesyłki" label="Wpisz numer przesyłki" style="flex: 1;">
                                </div>
                              <button type="submit" class="search-field__button" style="background-position: 10px 30px;">Search</button>
                              </div>
                            </div>
                            <div class="gr-5 gr-12@tablet gr-12@mobile gr-centered">
                                <div is="FormField"
                                    type="select"
                                    name="carrier"
                                    data-field="carrier"
                                    :value="carrier"
                                    placeholder=""
                                    label="Wybierz kuriera"
                                    v-model="carrier"
                                    :options="carriers"
                                    data-field="carrier">
                                    <template v-for="carrierCode in carriers">
                                        <option :value="carrierCode.id">{{carrierCode.text}}</option>
                                    </template>
                                </div>
                            </div>
                            <div class="gr-4 gr-12@tablet gr-12@mobile gr-centered">
                                <div class="form-field ">
                                    <button class="button button--primary button--full button--tablet-full form-field__control" @click="submit">Szukaj
                                        przesyłki
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>`
});

new Vue({
    el: '#application',
    components: {
        QuickOrderFormToggler
    },
    mounted: function () {
        initCarousel();
        initYoutube();
    }
})


function initCarousel() {
    $('.carousel').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1
                },
            },
        ],
    });
};

function initYoutube() {
    $('.media--youtube').each(function() {
        // $(this).css('background-image', 'url(' + static_url + 'images/filmik_kj.svg)');

        // Overlay the Play icon to make it look like a video player
        // $(this).append($('<div/>', {'class': 'play'}));
        $('#' + this.id).on('click', function() {
            // Create an iFrame with autoplay set to true
            var iframeUrl = 'https://www.youtube.com/embed/' + this.id + '?autoplay=1&autohide=1';
            if ($(this).data('params')) {
                iframeUrl += '&' + $(this).data('params');
            }

            // The height and width of the iFrame should be the same as parent
            var iframe = $('<iframe/>', {
                frameborder: '0',
                src: iframeUrl,
                width: $(this).width(),
                height: $(this).height()
            });

            // Replace the YouTube thumbn ail with YouTube HTML5 Player
            $(this).replaceWith(iframe);
        });
    });
};
